export const LINK_OPTIONS = [
  { label: '商品', value: 'goods', inputLable: '商品ID', placeholder: 'SAP商品编码' },
  { label: '专题', value: 'specialTopic', inputLable: '专题ID', placeholder: '专题ID' },
  { label: '设计师', value: 'designer', inputLable: '设计师', placeholder: '设计师编号' },
  // { label: '云样板间', value: 'demo', inputLable: '云样板间', placeholder: '样板间名称' },
  { label: '链接', value: 'link', inputLable: '链接', placeholder: 'http或https链接' },
  { label: '优惠券', value: 'coupon', inputLable: '优惠券', placeholder: '优惠券设定ID' },
  { label: '无跳转', value: 'none' },
];
